<template>
<v-app>
    <v-container fluid class="mt-10">
        <v-row>
            <v-col cols="12">
                <h5>Veuillez choisir un organisme de crédit</h5>
            </v-col>
            <v-col>
                <v-btn color="primary" small v-on:click="goToBmci()">BMCI</v-btn>
            </v-col>
            <v-col>
                <v-btn color="primary" small v-on:click="goToVivalis()">Vivalis</v-btn>
            </v-col>
        </v-row>
    </v-container>
</v-app>
</template>

<script>
export default {
    name: 'Organisation',
    data() {
        return {

        }
    },
    mounted() {},
    props: ["tarif", "periodeId"],
    methods: {
        goToBmci: function () {
            this.$router.push({
                name: "BmciAccueil",
                params: {
                    tarif: this.tarif,
                    periodeId: this.periodeId
                }
            })
        },
        goToVivalis: function () {
            this.$router.push({
                name: "VivalisAccueil",
                params: {
                    tarif: this.tarif,
                    periodeId: this.periodeId
                }
            })
        }
    }
}
</script>
